import {Component, Input, OnInit} from '@angular/core';
import { ReservationService } from "../../../services/reservation";
import { HttpErrorResponse } from "@angular/common/http";
import { Reservation } from "../../../classes/reservation";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "../../../classes/user";

@Component({
  selector: 'app-inspection-view-reservation-modal',
  templateUrl: './inspection-view-reservation-modal.component.html',
  styleUrls: ['./inspection-view-reservation-modal.component.css']
})
export class InspectionViewReservationModalComponent implements OnInit {

  reservations: Array<Reservation> = [];
  userSelected = new User();
  @Input() public setIDInspection = (idInspection: string) => {
    this.reservationService.getByIDInspection(idInspection)
        .subscribe({
          next: (reservations: any) => {
            this.reservations = reservations;
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
          }
        });
  }

  constructor(public activeModal: NgbActiveModal,
              private reservationService: ReservationService) { }

  ngOnInit(): void {}

  passBack() {
      this.activeModal.close(this.userSelected);
  }

}
